import React, { Component } from 'react';
import _ from 'lodash';
import cx from 'classnames';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
    Theme,
    createStyles,
    withStyles,
    WithStyles,
    Card,
    CardContent,
    Grid,
    Typography,
    Chip,
    Button,
    FormGroup,
    FormControlLabel,
    Checkbox
} from '@material-ui/core';
import {
    MyPATDialog,
    MyPATTextField,
    MyPATSelect,
    SearchField
} from '../../../common';
import GoalMockData from '../../__mocks__/content';
import { getCourseData } from '../../actions/goalManagementActions';
import goalManagementService from '../../services/goalManagementService';


const styles = (theme: Theme) => createStyles({
    mb1x: {
        marginBottom: theme.spacing.unit,
    },
    cardContentRoot: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        '&:last-child': {
            paddingBottom: theme.spacing.unit * 2,
        },
    },
    ssChip: {
        marginTop: theme.spacing.unit / 2,
        marginRight: theme.spacing.unit,
        '& span': {
            fontWeight: 600,
            color: "#6d6d6d"
        },
        '&:hover': {
            backgroundColor: theme.palette.grey[300],
        },
        '&:focus': {
            backgroundColor: theme.palette.grey[300],
        }
    },
    activeChip: {
        background: theme.palette.primary.main,
        '& span': {
            fontWeight: 600,
            color: "#fff"
        },
        '&:hover': {
            background: theme.palette.primary.main,
        },
        '&:focus': {
            background: theme.palette.primary.main,
        }
    },
    suggestContainer: {
        position: 'relative',
    },
    chipDiv: {
        padding: theme.spacing.unit / 2,
    },
    addNew: {
        padding: theme.spacing.unit
    },
    saveClass: {
        paddingTop: theme.spacing.unit * 5,
        textAlign: "right",
    },
    searchSubSubjectGroupRoot: {
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: theme.shape.borderRadius,
        padding: `0 ${theme.spacing.unit}px`,
    },
    addSubSubject: {
        float: "right",
        cursor: "pointer",
    },
    suggestList: {
        position: 'absolute',
        width: '100%',
        height: 'auto',
        top: '34px',
        left: '0',
        padding: 0,
        marginTop: 0,
        zIndex: 1,
        listStyleType: 'none',
        backgroundColor: theme.palette.common.white,
        boxShadow: theme.shadows[1],
        borderRadius: `0 0 ${theme.shape.borderRadius}px ${theme.shape.borderRadius}px`,
        '& li': {
            ...theme.typography.body2,
            fontWeight: theme.typography.fontWeightRegular,
            display: 'block',
            padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
            '&:hover': {
                backgroundColor: theme.palette.grey[300],
            },
        }
    },
    showOverFlow: {
        overflow: "visible !important"
    },
    hideChip: {
        display: 'none',
        pointerEvents: 'none',
    }
});

interface ChaptersAddDialogProps extends WithStyles<typeof styles> {
    isDialogOpen: boolean,
    dialogCloseHandler: () => void,
    selectedList: any,
    activeCourse: any,
    selectedGoal: any,
    chapterList: any,
    getCourseData: (courseId: string) => void,
    subSubjectDetail: any;
    courseData: any,

}

interface ChaptersAddDialogState {
    activeChapter: boolean,
    showSuggestedChapterGroup: boolean,
    selectChapter: any[],
    suggestedChapter: any[],
    formData: {
        chapterName?: string,
    },
    errForm: {
        chapterName: { message: string }
    },
    tempChapterList: any[],
    removedSelectedList: string[],
    updateProps: boolean,
    localllyAddIds: any[],
    searchList: any[],
}

class ChaptersAddDialog extends Component<ChaptersAddDialogProps, ChaptersAddDialogState> {
    constructor(props: ChaptersAddDialogProps) {
        super(props);
        this.state = {
            activeChapter: false,
            showSuggestedChapterGroup: false,
            selectChapter: [],
            tempChapterList: [],
            formData: {
                chapterName: '',
            },
            errForm: {
                chapterName: { message: '' },
            },
            suggestedChapter: [],
            removedSelectedList: [],
            updateProps: true,
            localllyAddIds: [],
            searchList: []
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubSubjectSave = this.handleSubSubjectSave.bind(this);
        this.handleChip = this.handleChip.bind(this);
        this.handleAddTo = this.handleAddTo.bind(this);
        this.dCloseHandler = this.dCloseHandler.bind(this);
    }

    resetForm = () => {
        const formData = {
            chapterName: ''
        };
        return this.setState({ formData, activeChapter: false, selectChapter: [], tempChapterList: [], updateProps: true, removedSelectedList: [], localllyAddIds: [] });
    }

    componentWillUnmount() {

    }

    dCloseHandler() {
        this.resetForm();
        this.props.dialogCloseHandler();
    }


    static getDerivedStateFromProps(nextProps: any, prevState: any) {
        if (prevState.updateProps) {
            let selectedList = nextProps.selectedList;
            let mChapter: any[] = [];
            let selectedIds: any = [];
            let masterC: any[] = !_.isEmpty(nextProps.chapterList) ? nextProps.chapterList : [];


            if (!_.isUndefined(selectedList["chapter"])) {
                let id = nextProps.selectedGoal;
                id = id ? id.selectedSubSubject : "";
                mChapter = id && selectedList["chapter"][id] ? Object.values(selectedList["chapter"][id]) : [];
                mChapter = Array.prototype.concat.apply([], mChapter);

                mChapter && mChapter.map((c: any) => {
                    c["visible"] = false;
                    _.isArray(c.masterIDs) && selectedIds.push(...c.masterIDs);

                    return c;
                });
            }
            if (_.isArray(masterC) && !_.isEmpty(selectedIds)) {
                masterC.map((ss: any) => {
                    if (selectedIds.includes(ss._id)) {
                        ss["visible"] = false;
                    }
                    return ss;
                })
            }

            return {
                selectChapter: mChapter,
                tempChapterList: masterC,
                searchList: masterC,
            }
        }
        else
            return null;
    }



    handleInputChange = (evt: any) => {
        let { formData, suggestedChapter }: any = this.state;
        const { name, value } = evt.target;
        formData[name] = value ? value.trimLeft() : '';
        suggestedChapter = this.searchChapter(true, evt);
        this.setState({ formData, suggestedChapter });

    }


    handleAddTo = () => {
        let { selectChapter, removedSelectedList, localllyAddIds } = this.state;
        let { activeCourse, chapterList, selectedList, subSubjectDetail, courseData } = this.props;
        if (selectChapter) {
            let chapterFormData: any = {};
            let requestForm: any = [];
            let ac: any = [];
            let chapterId = "";
            let tempArray: any = [];
            let mId: string[] = [];
            let classes: any = [];
            let lastChapterOrder = 0;
            selectChapter.forEach((sC: any) => {
                let orderNo;
                let sequenceNumber;

                classes = _.isEmpty(subSubjectDetail.classes) ? [] : subSubjectDetail.classes;
                ac = [];
                chapterFormData = {};
                ac = _.get(subSubjectDetail, 'ancestors');
                chapterId = _.get(subSubjectDetail, '_id');
                ac.push(chapterId);
                ac = Array.from(new Set(ac));

                if (sC.orderNo) {
                    orderNo = sC.orderNo;
                    lastChapterOrder = orderNo;
                } else {
                    ++lastChapterOrder;
                    orderNo = lastChapterOrder;
                }
                if (sC.sequenceNumber) {
                    sequenceNumber = sC.sequenceNumber;
                } else {
                    let order = (orderNo < 10) ? '0' + orderNo.toString() : orderNo.toString();
                    sequenceNumber = subSubjectDetail.sequenceNumber + order;
                }
                let uniqueCode = !sC.uniqueCode ? goalManagementService.generateUniqueCode(courseData, ac, orderNo, 'chapter') : sC.uniqueCode;



                //Check whether its for update
                //If it has master id then its for add new
                if (sC["masterIDs"] && sC["masterIDs"].length > 0) {
                    mId = sC["masterIDs"];
                } else {
                    //If its newely created class then make master id as empty
                    if (localllyAddIds.includes(sC._id)) {
                        mId = [];
                    }
                    //It's for updated pass _id as default;
                    else {
                        mId = [sC._id]
                    }
                }

                chapterFormData = {
                    name: sC.name,
                    type: 'chapter',
                    courseId: _.get(activeCourse, '_id', ''),
                    courseItemID: activeCourse.courseItems[0].id,
                    ancestors: ac,
                    parent: chapterId,
                    masterIDs: mId,
                    classes: classes,
                    isLocal: localllyAddIds.includes(sC._id) ? true : false,
                    orderNo: orderNo,
                    uniqueCode: uniqueCode,
                    sequenceNumber: sequenceNumber

                }

                if ((sC["masterIDs"] && sC["masterIDs"].length > 0) || sC["isLocal"]) {
                    chapterFormData["_id"] = sC._id;
                }
                tempArray.push(chapterFormData);
            });

            let a = { chapterD: tempArray, removedIds: removedSelectedList };
            requestForm.push(a);

            goalManagementService.saveCourseSyllabus(requestForm)
                .then((resObj) => {
                    this.resetForm();
                    this.props.dialogCloseHandler();
                    this.props.getCourseData(activeCourse._id);
                })
        }
    }



    handleChip = (chapterData: any, evt: any) => {
        let { selectChapter, removedSelectedList, updateProps, localllyAddIds } = this.state;
        let { selectedList } = this.props;
        if (chapterData) {
            let tempSelectedData : any = [];
            let chapterId = chapterData._id;
            let isPresent = false;

            //already present remove it since user clicked double time
            selectChapter.forEach((sS: any, i: number) => {
                if (!(sS._id == chapterId || sS.masterIDs && sS.masterIDs.includes(chapterId))) {
                    tempSelectedData.push(sS);
                } else {
                    isPresent = true;
                    if (!_.isEmpty(selectedList["chapter"]) && !localllyAddIds.includes(sS._id)) {
                        removedSelectedList.push(sS._id);
                    }
                }
            });
            if (!isPresent) {
                selectChapter.push(chapterData);
                tempSelectedData = selectChapter;
            }
            this.setState({ selectChapter: tempSelectedData, removedSelectedList, updateProps: false });

        }
    }


    handleSubSubjectSave = () => {
        let { formData, errForm, tempChapterList, selectChapter, localllyAddIds } = this.state;
        errForm["chapterName"]["message"] = formData["chapterName"] && formData["chapterName"] != '' ? '' : 'Enter Chapter Name';
        if (_.isEmpty(errForm["chapterName"]["message"])) {


            let chapterId: string = `${formData["chapterName"]}${new Date().getTime()}`;
            let subSubjectObj = { name: formData["chapterName"], _id: chapterId };

            tempChapterList.push(subSubjectObj);
            selectChapter.push(subSubjectObj);

            localllyAddIds.push(chapterId);

            formData = {
                chapterName: ''
            }

            this.setState({ tempChapterList, selectChapter, formData, activeChapter: false, updateProps: false, localllyAddIds });

        }
        this.setState({ errForm });
    }

    //This function will be used for both searching at both places
    searchChapter = (shouldReturn: boolean = false, evt: any) => {
        let { value } = evt.target;
        let { tempChapterList, updateProps } = this.state;
        let { chapterList } = this.props;
        let tempList : any = [];
        tempChapterList = chapterList;
        if (value) {
            tempChapterList && tempChapterList.forEach((subj: any) => {
                if (value && subj && subj.name && subj.name.toLowerCase().search(value.toLowerCase()) != -1) {
                    tempList.push(subj);
                }
            });
        } else {
            tempList = tempChapterList;
        }
        return !shouldReturn ? this.setState({ tempChapterList: tempList, updateProps: false }) : tempList;
    }

    render() {
        const {
            classes,
            isDialogOpen,
            subSubjectDetail
        } = this.props;

        const {
            formData,
            activeChapter,
            errForm,
            selectChapter,
            tempChapterList,
            showSuggestedChapterGroup,
            suggestedChapter
        } = this.state;

        const otherDialogProps = {
            fullWidth: true,
            maxWidth: 'md',
            scroll: 'body',
        }

        let getChipActive = (chapterId: string) => {
            let isPresent = false;
            let hasVisible = false;
            selectChapter.map(sS => {
                if ((sS && sS._id == chapterId) || (sS.masterIDs && sS.masterIDs.includes(chapterId))) {
                    isPresent = true;
                }

                if (isPresent) {
                    hasVisible = isPresent && _.isEqual(sS["visible"], false) ? true : hasVisible;
                }
            });
            return isPresent && hasVisible ? `${classes.hideChip}` : isPresent ? classes.activeChip : '';

        }


        return (
            <MyPATDialog
                dialogHeading={`Add Chapter in ${_.get(subSubjectDetail, 'name', '')}`}
                dialogOpen={isDialogOpen}
                otherDialogProps={otherDialogProps}
                onDialogClose={this.dCloseHandler}
            >
                <Card>
                    <CardContent className={classes.cardContentRoot}>
                        <Grid container spacing={8} alignItems="center">
                            <Grid item xs={12} className={classes.mb1x}>
                                <MyPATTextField
                                    inputId="newTestType"
                                    name="newTestType"
                                    onChange={this.searchChapter.bind(this, false)}
                                    placeholder="Search Chapter"
                                    fullWidthControl
                                >
                                </MyPATTextField>
                                <Grid item xs={12}>
                                    <Typography variant="body2" align="left">Chapter Name</Typography>
                                    {
                                        _.map(tempChapterList, (chapter, j) => (
                                            <Chip
                                                classes={{ root: classes.ssChip }}
                                                className={getChipActive(chapter._id)}
                                                clickable={true}
                                                key={`${chapter._id} ${j}`}
                                                label={chapter.name}
                                                onClick={this.handleChip.bind(this, chapter)}
                                            />
                                        ))

                                    }
                                </Grid>
                            </Grid>
                        </Grid>

                    </CardContent>
                </Card>
                <Grid item className={classes.addNew} container>
                    <Grid item xs={12}>
                        {
                            !activeChapter
                                ?
                                <Button onClick={() => { this.setState({ activeChapter: !activeChapter }) }} color="primary">Add New Chapter</Button>
                                :
                                ''
                        }

                        {
                            activeChapter ?
                                <Card className={classes.showOverFlow}>
                                    <CardContent className={classes.cardContentRoot}>
                                        <Grid container className={classes.mb1x} item xs={12}>
                                            <Grid item xs={6}>
                                                <Typography variant="body1">Create Chapter</Typography>
                                                <div className={classes.suggestContainer}>
                                                    <MyPATTextField
                                                        name="chapterName"
                                                        id="chapterName"
                                                        placeholder="Enter Chapter Name"
                                                        error={errForm.chapterName.message != '' ? true : false}
                                                        errorText={errForm.chapterName.message}
                                                        className={classes.searchSubSubjectGroupRoot}
                                                        value={formData.chapterName || ''}
                                                        onFocus={() => { this.setState({ showSuggestedChapterGroup: true }) }}
                                                        onBlur={() => { setTimeout(() => { this.setState({ showSuggestedChapterGroup: false }) }, 500) }}
                                                        onChange={this.handleInputChange}
                                                        fullWidth
                                                    />
                                                    
                                                    {showSuggestedChapterGroup && suggestedChapter.length > 0 && (
                                                        <ul className={classes.suggestList}>
                                                            <li><Typography variant="caption">Available Chapters</Typography></li>
                                                            {_.map(suggestedChapter, (cap, i: number) => (
                                                                !_.isEqual(cap.visible, false) &&
                                                                <li key={i}
                                                                >
                                                                    <Typography inline align="left" variant="subtitle2">{cap.name}</Typography>
                                                                    <Typography
                                                                        className={classes.addSubSubject}
                                                                        inline
                                                                        align="right"
                                                                        variant="body1"
                                                                        onClick={this.handleChip.bind(this, cap)}
                                                                    >
                                                                        Add
                                                                    </Typography>

                                                                </li>
                                                            ))}
                                                        </ul>
                                                    )}
                                                </div>
                                            </Grid>
                                            <Grid item xs={6} className={`${classes.mb1x} ${classes.saveClass}`}>
                                                <Button onClick={this.handleSubSubjectSave} color="primary">Save Chapter</Button>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                                : ''
                        }
                    </Grid>
                    <Grid item xs={12} className={classes.saveClass}>
                        <Button onClick={this.handleAddTo} variant="contained" color="primary">{`Add to ${_.get(subSubjectDetail, 'name', '')}`}</Button>
                    </Grid>
                </Grid>
            </MyPATDialog>
        )
    }
}


const mapStateToProps = (state: any) => ({
    chapterList: _.get(state, 'goalManagement.goalManagement.chapterList', []),
    courseData: _.get(state, 'goalManagement.goalManagement.courseData', [])
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
    getCourseData,
}, dispatch);

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ChaptersAddDialog));